module.exports = __webpack_public_path__ + "media/hyper/images/projects/project-4-143d446e1f8fc242dd040102267c6621.jpg";